<div class="mi-hamburger">

    <button class="mi-hamburger-button" (click)="toggleMenu()" [attr.aria-expanded]="sidebarVisible"
        aria-label="Toggle Menu">
        <div class="mi-hamburger-button-icon-line"></div>
        <div class="mi-hamburger-button-icon-line"></div>
        <div class="mi-hamburger-button-icon-line"></div>
    </button>

    <nav class="mi-navigation-menu" [class.open]="sidebarVisible" [class.close]="!sidebarVisible">


        <ul>
            <li>
                <div class="mi-navigation-menu-item h-3 d-flex justify-content-end align-items-center">

                    <mc-button class="mi-transparent-button" [label]="'X'" (click)="closeMenu()"></mc-button>


                </div>
            </li>
            <li>
                <div class="mi-navigation-menu-item-section">
                    <div class="h-3 mi-navigation-menu-item d-flex justify-content-between align-items-center">
                        <span>עברית</span>
                        <i class="icon-Color-Overlay  cursor-pointer fw-bolder" (click)="toggleLanguage()"
                            [ngClass]="{'close-i': !isCloseLanguage}" tabindex="0" role="button"
                            (keyup.enter)="toggleLanguage()"></i>
                    </div>
                    @if(!isCloseLanguage){


                    <div class="mi-navigation-menu-item-section-content">
                        <div class="h-3 fw-bold d-flex align-items-center">
                            <span class="">
                                עברית
                            </span>

                        </div>
                        <!-- <div class="h-3  fw-bold">
                            <span>
                                אנגלית
                            </span>
                        </div>
                        <div class="h-3 ">
                            <span>
                                ערבית
                            </span>
                        </div> -->
                    </div>
                    }
                </div>

            </li>
            <li>
                <div class="h-3 mi-navigation-menu-item d-flex justify-content-between align-items-center">
                    <span>עזרה ומדריכים</span>
                    <i class="icon-Color-Overlay  cursor-pointer fw-bolder" (click)="toggleHelpInformation()"
                        [ngClass]="{'close-i': !isCloseHelpInformation}" tabindex="0" role="button"
                        (keyup.enter)="toggleHelpInformation()"></i>
                </div>
            </li>
            <li>
                <div class="h-3 mi-navigation-menu-item d-flex justify-content-between  align-items-center">
                    <a href="tel:1299">שיחה למוקד המענה הממשלתי</a>
                    <i class="icon-phone-call-1"> </i>
                </div>
            </li>
        </ul>



    </nav>

</div>